const CTASection = () => {
  return (
    <section className="relative bg-[#F2F4F7] py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-64 h-64 bg-[#3D8BFF] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#A9C9FF] rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-6xl lg:text-7xl font-bold text-[#2F6FE4] mb-8">
          Start Selling Business
          <br />
          <span className="font-extrabold text-[#3D8BFF]">Credit Services Today</span>
        </h2>
        <p className="text-xl text-[#555555] mb-8">
          Join our broker network and access wholesale pricing with full fulfillment support
        </p>

        {/* Financing Banner */}
        <div className="inline-flex items-center gap-3 bg-white border border-[#A9C9FF] px-6 py-3 rounded-full mb-10 shadow-md">
          <div className="w-8 h-8 flex items-center justify-center bg-[#A9C9FF] rounded-full flex-shrink-0">
            <i className="ri-money-dollar-circle-fill text-[#2F6FE4] text-lg"></i>
          </div>
          <span className="text-[#555555] font-bold text-base tracking-wide">
            Financing Available — Up to <span className="text-[#3D8BFF]">$100,000</span> for Purchases
          </span>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
          <a
            href="#apply"
            className="bg-[#2F6FE4] text-white px-12 py-5 rounded-full font-bold text-lg hover:bg-[#3D8BFF] transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            Apply for Broker Access
          </a>
          <a
            href="#contact"
            className="border-2 border-[#2F6FE4] text-[#2F6FE4] px-12 py-5 rounded-full font-bold text-lg hover:bg-[#2F6FE4] hover:text-white transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Book a Strategy Call
          </a>
        </div>

        {/* Fund Me Button */}
        <div className="flex justify-center">
          <a
            href="https://app.flexxbuy.com/fast-funding-capital-llc/apply/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-green-600 transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-funds-line text-xl"></i>
            Fund Me
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;